<mat-accordion class="rsb-list-item">
    <mat-expansion-panel class="rsb-list-item-xp"  *ngFor="let listItem of rsbListItems">
        <mat-expansion-panel-header class="rsb-list-item-hd" [collapsedHeight]="'42px'" [expandedHeight]="'42px'" >
            <span>            
                <itb-color-bar *ngIf="listItem.hasColorBar" [className]="listItem.colorBarClassName"></itb-color-bar>
                <itb-text [className]="listItem.textClassName" [text]="listItem.text"></itb-text>
            </span>
            <itb-dropdown-list [dropDownButton]="listItem.dropDownButton" [items]="listItem.dropdownItems" (onClickHandler)="onClick($event)"></itb-dropdown-list>
        </mat-expansion-panel-header>
        <ng-content></ng-content>
    </mat-expansion-panel>
</mat-accordion>